export const rustDefaultSource = `// println! macros will be matched by pattern!
// click diff tab to see rewrite and import addition.

fn main() {
    println!("Starting application");
    
    let user_id = 42;
    println!("User ID: {}", user_id);
    
    if let Some(config) = load_config() {
        println!("Config loaded: {:?}", config);
    } else {
        println!("Failed to load config");
    }
    
    // This is a comment with println!("not matched")
    let debug_msg = "println!(\\"also not matched\\")";
    
    match process_data() {
        Ok(result) => {
            println!("Processing completed successfully: {:?}", result);
        }
        Err(e) => {
            println!("Error processing data: {}", e);
        }
    }
}

fn load_config() -> Option<String> {
    Some("config".to_string())
}

fn process_data() -> Result<String, String> {
    Ok("data".to_string())
}`;

export const rustDefaultCodemod = `import { type SgRoot } from "@ast-grep/napi";

async function transform(root: SgRoot): Promise<string> {
  const rootNode = root.root();

  // Find all println! macro calls
  const nodes = rootNode.findAll({
    rule: {
      pattern: "println!($$$ARGS)"
    },
  });

  if (nodes.length === 0) {
    return rootNode.text(); // No changes needed
  }

  // Check if log::info is already imported
  const hasLogImport = rootNode.find({
    rule: {
      any: [
        { pattern: "use log::info;" },
        { pattern: "use log::*;" },
        { pattern: "use log::{$$$, info, $$$};" },
      ]
    }
  });

  const edits = [];

  // Add import if not present
  if (!hasLogImport) {
    // Find the best place to insert the import
    const firstUseStatement = rootNode.find({
      rule: { pattern: "use $$$;" }
    });
    
    if (firstUseStatement) {
      // Insert before the first use statement
      edits.push(firstUseStatement.replace(\`use log::info;
\${firstUseStatement.text()}\`));
    } else {
      // No existing imports, add at the beginning of the file
      const firstItem = rootNode.children()[0];
      if (firstItem) {
        edits.push(firstItem.replace(\`use log::info;

\${firstItem.text()}\`));
      }
    }
  }

  // Transform all println! calls
  nodes.forEach(node => {
    const args = node
      .getMultipleMatches("ARGS")
      .map(x => x.text())
      .filter(x => x !== ',')
      .join(', ') || "";
    edits.push(node.replace(\`log::info!(\${args})\`));
  });

  const newSource = rootNode.commitEdits(edits);
  return newSource;
}

export default transform;
`;

export const rustDefaultConfig = `
# Codemod Studio uses ast-grep to match and rewrite code.
# https://ast-grep.github.io/guide/rule-config.html#rule
id: replace-println-with-logging
language: rust
rule:
  pattern: println!($$$ARGS)
fix:
  log::info!($$$ARGS)
`.trim();
